import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  monthlyTrendList: [],
  isMonthlyTrendLoading: false,
  recommendMerchantList: [],
  popularBoardList: [],
};

const fetchPopularBoardList = createAsyncThunk(
  "home/fetchPopularBoardList",
  async () => {
    try {
      const { data } = await axios.get("https://node.floway.co.kr/boards/best");
      const payload = data;
      return payload;
    } catch (e) {
      console.error(e);
    }
  }
);

const fetchMonthlyTrendData = createAsyncThunk(
  "home/fetchMonthlyTrendData",
  async () => {
    const thisMonth = new Date().getMonth() + 1;
    try {
      const { data } = await axios.get(
        `https://api.floway.co.kr/api/flowers/trend/${thisMonth}`
      );
      const payload = data?.data;
      return payload;
    } catch (e) {
      console.error(e);
    }
  }
);

const fetchRecommendMerchantData = createAsyncThunk(
  "home/fetchRecommendMerchantData",
  async () => {
    try {
      const { data } = await axios.get(
        `https://api.floway.co.kr/api/wholesales/recommendList`
      );
      const payload = data?.data;
      return payload;
    } catch (e) {
      console.error(e);
    }
  }
);

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMonthlyTrendData.pending, (state) => {
        state.isMonthlyTrendLoading = false;
      })
      .addCase(fetchMonthlyTrendData.fulfilled, (state, action) => {
        state.monthlyTrendList = action.payload;
        state.isMonthlyTrendLoading = true;
      })
      .addCase(fetchMonthlyTrendData.rejected, (state) => {
        state.isMonthlyTrendLoading = true;
      });

    builder
      .addCase(fetchRecommendMerchantData.pending, () => {})
      .addCase(fetchRecommendMerchantData.fulfilled, (state, action) => {
        state.recommendMerchantList = action.payload;
      })
      .addCase(fetchRecommendMerchantData.rejected, () => {});

    builder
      .addCase(fetchPopularBoardList.pending, () => {})
      .addCase(fetchPopularBoardList.fulfilled, (state, action) => {
        state.popularBoardList = action.payload;
      })
      .addCase(fetchPopularBoardList.rejected, () => {});
  },
});

const HomeCreators = {
  fetchMonthlyTrendData,
  fetchRecommendMerchantData,
  fetchPopularBoardList,
};

export { HomeCreators };
const { reducer } = homeSlice;
export default reducer;
